import { Grid, Paper } from '@material-ui/core';
import {
  DateRange,
  Description,
  LocationOn as LocationOnIcon,
  Restore as RestoreIcon,
  SchoolRounded as SchoolIcon,
  Work as WorkIcon,
} from '@material-ui/icons';
import { addViewOffer } from '@webapps/business';
import {
  Button,
  ModalSideBar,
  useMutation,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarCompany from 'components/Avatar/AvatarCompany';
import HourglassHalf from 'components/Icons/HourglassHalf';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import Modal from 'components/ModalLarge';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import theme from '../../theme';
import DetailsAnnonce from 'components/DetailsAnnonce';

const {
  colors: { itemColor },
} = theme;

const CardOffer = ({
  address,
  contrat,
  item,
  lastTimeView,
  name,
  typeFormation,
}) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);
  const date = new Date();

  const [viewOffre, setViewOffre] = useState(false);

  const handleOpenOffre = () => {
    setViewOffre(true);
  };
  const handleCloseOffre = () => {
    setViewOffre(false);
  };

  const { mutateAsync: mutateAddView } = useMutation(addViewOffer);

  useEffect(() => {
    if (viewOffre && item?.id) {
      mutateAddView({
        id: item?.id,
      });
    }
  }, [viewOffre]);

  return (
    <>
      <Paper className={classes.paper} elevation={0} onClick={() => setViewOffre(true)}>
        <div className={cx(global.title, classes.title)}>
            <AvatarCompany
              height={70}
              idCompany={item?.business?.id || item?.businessExternal}
              name={item?.business?.name || item?.businessExternal?.name}
              width={70}
            />
          <div style={{ marginLeft: spacing(1) }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span>{name.label}</span>
              <span
                style={{
                  display: 'flex',
                  color: '#152652',
                  marginTop: spacing(1),
                }}
                className={global.infoText}
              >
                {item?.business?.name || item?.businessExternal?.name}{' '}
                {item?.business && (
                  <span className={css({ marginLeft: spacing(1) })}>
                    {' '}
                    <VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />
                  </span>
                )}
              </span>
            </div>
          </div>
        </div>
        <div className={classes.items}>
          <div className={classes.cardContainer}>
            <div className={classes.cardItem}>
              <LocationOnIcon className={global.infoIcon} />
              <p style={{margin: 0}} className={cx(global.infoText, global.ellipsis85)}>
                {address.cityCode} {address.city}
              </p>
            </div>
            <div className={classes.cardItem}>
              <Description className={global.infoIcon} />
              <p style={{margin: 0}} className={cx(global.infoText, global.ellipsis85)}>{contrat.label}</p>
            </div>
          </div>
          <div className={classes.cardContainer}>
            <div className={classes.cardItem}>
              <HourglassHalf className={global.infoIcon}/>
              <p style={{margin: 0}} className={cx(global.infoText, global.ellipsis85)}> {item.contractLength} mois de contrat</p>
            </div>
            <div className={classes.cardItem}>
              <SchoolIcon className={global.infoIcon} />
              <p style={{margin: 0}} className={cx(global.infoText, global.ellipsis85)}>{typeFormation.label}</p>
            </div>
          </div>
        </div>
      </Paper>
      <ModalSideBar
        handleClose={handleCloseOffre}
        open={viewOffre}
        title={name?.label}
      >
        <DetailsAnnonce info={item} />
      </ModalSideBar>
    </>
  );
};

const styles = ({ spacing }) => ({
  paper: {
    padding: '20px',
    borderRadius: 10,
    width: '49%',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #C0D9FF',
    transition: 'all 0.2s',
    '&:hover': {
      transition: 'all 0.2s',
      border: '1px solid #0060F9',
      'h1': {
        transition: 'all 0.2s',
        color: '#0060F9',
      },
      'p': {
        transition: 'all 0.2s',
        color: '#152652',
      },
      'svg': {
        transition: 'all 0.2s',
        color: '#0060F9',
      }
    },
    cursor: 'pointer',
    '@media (max-width:1520px)': { width: '48.7%' },
    '@media (max-width:1200px)': { width: '100%' },
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    color: '#5D75A8',
    marginBottom: '10px',
    marginTop: 0,
    fontWeight: '400',
    transition: 'all 0.2s',
  },
  cardContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  cardItem: {
    display: 'flex',
    width: '50%',
    alignItems: 'center',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
  },
  items: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '10px',
  },
  itemText: {
    margin: spacing(0, 0, 0, 0.5),
  },
});

CardOffer.propTypes = {
  address: PropTypes.object,
  contrat: PropTypes.object,
  lastTimeView: PropTypes.string,
  name: PropTypes.object,
  typeFormation: PropTypes.object,
  item: PropTypes.object,
};

export default CardOffer;
